import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "continueInApp" }
const _hoisted_2 = { class: "continueInApp_content" }
const _hoisted_3 = { class: "continueInApp_head" }
const _hoisted_4 = { class: "continueInApp_title" }
const _hoisted_5 = { class: "continueInApp_desc" }
const _hoisted_6 = {
  class: "continueInApp_benefits",
  "data-test": "continue-benefits"
}
const _hoisted_7 = { class: "continueInApp_benefit" }
const _hoisted_8 = { class: "continueInApp_benefitText" }
const _hoisted_9 = { class: "continueInApp_benefit" }
const _hoisted_10 = { class: "continueInApp_benefitText" }
const _hoisted_11 = { class: "continueInApp_benefit" }
const _hoisted_12 = { class: "continueInApp_benefitText" }
const _hoisted_13 = { class: "continueInApp_actions" }

import { MqResponsive } from 'vue3-mq'

import AcButton from '@ui-kit/components/AcButton.vue'
import AcImage from '@web/ui-kit/components/AcImage/index.vue'
import Token from '@web/common/token'
import { postFirstDayModalCtaClicked, postFirstDayModalRedirectApp } from '@web/services/Analytics/events'
import type { CloseMethod } from '@web/services/Analytics/events/postFirstDayModal'
import { buildOneLink } from './oneLink'
import illustrationDesktop from '@web/assets.v2/post-first-day/continue-illustration-desktop.jpg'
import illustrationMobile from '@web/assets.v2/post-first-day/continue-illustration-mobile.jpg'
import qrCode from '@web/assets.v2/post-first-day/qr-code.png'


export default /*@__PURE__*/_defineComponent({
  __name: 'ContinueInAppContent',
  emits: ["close", "cta"],
  setup(__props, { emit: __emit }) {

const emit = __emit

// CTA существует только на мобайле (десктоп уводит через QR), поэтому platform_view фиксирован.
function onCta (): void {
  postFirstDayModalCtaClicked({ modalType: 'continue_in_app', platformView: 'mobile_web' })
  postFirstDayModalRedirectApp()
  window.open(buildOneLink(Token.get()), '_blank')
  emit('cta')
}

function onClose (method: CloseMethod): void {
  emit('close', method)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(MqResponsive), {
      target: "mobile-tablet",
      class: "continueInApp_illustration"
    }, {
      default: _withCtx(() => [
        _createVNode(AcImage, {
          src: _unref(illustrationMobile),
          "aspect-ratio": "720 / 566",
          "object-fit": "cover",
          alt: ""
        }, null, 8, ["src"]),
        _createElementVNode("button", {
          class: "continueInApp_close -onImage",
          "data-test": "continue-close",
          "aria-label": "Закрыть",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (onClose('cross_button')))
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("svg", {
            width: "28",
            height: "28",
            viewBox: "0 0 28 28",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("g", { "clip-path": "url(#clip0_24929_239821)" }, [
              _createElementVNode("path", {
                d: "M14 12.3502L18.9502 7.40003C19.4057 6.94449 20.1443 6.94449 20.5998 7.40003C21.0554 7.85557 21.0554 8.59415 20.5998 9.0497L15.6496 13.9999L20.5998 18.95C21.0554 19.4056 21.0554 20.1442 20.5998 20.5997C20.1443 21.0552 19.4057 21.0552 18.9502 20.5997L14 15.6495L9.04982 20.5997C8.59427 21.0552 7.85569 21.0552 7.40015 20.5997C6.94461 20.1442 6.94461 19.4056 7.40015 18.95L12.3503 13.9999L7.40015 9.0497C6.94461 8.59415 6.94461 7.85557 7.40015 7.40003C7.85569 6.94449 8.59427 6.94449 9.04982 7.40003L14 12.3502Z",
                fill: "white"
              })
            ]),
            _createElementVNode("defs", null, [
              _createElementVNode("clipPath", { id: "clip0_24929_239821" }, [
                _createElementVNode("rect", {
                  width: "28",
                  height: "28",
                  fill: "white"
                })
              ])
            ])
          ], -1)
        ]))]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "continueInApp_illustrationGradient" }, null, -1))
      ]),
      _: 1
    }),
    _createVNode(_unref(MqResponsive), {
      target: "desktop",
      class: "continueInApp_illustration -desktop",
      "data-test": "continue-qr"
    }, {
      default: _withCtx(() => [
        _createVNode(AcImage, {
          src: _unref(illustrationDesktop),
          "aspect-ratio": "766 / 600",
          "object-fit": "cover",
          alt: ""
        }, null, 8, ["src"]),
        _createVNode(AcImage, {
          class: "continueInApp_qr",
          src: _unref(qrCode),
          width: 160,
          height: 160,
          radius: 12,
          "object-fit": "cover",
          alt: "QR"
        }, null, 8, ["src"]),
        _createElementVNode("button", {
          class: "continueInApp_close -onImage",
          "data-test": "continue-close",
          "aria-label": "Закрыть",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (onClose('cross_button')))
        }, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("svg", {
            width: "28",
            height: "28",
            viewBox: "0 0 28 28",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("g", { "clip-path": "url(#clip0_24929_239821)" }, [
              _createElementVNode("path", {
                d: "M14 12.3502L18.9502 7.40003C19.4057 6.94449 20.1443 6.94449 20.5998 7.40003C21.0554 7.85557 21.0554 8.59415 20.5998 9.0497L15.6496 13.9999L20.5998 18.95C21.0554 19.4056 21.0554 20.1442 20.5998 20.5997C20.1443 21.0552 19.4057 21.0552 18.9502 20.5997L14 15.6495L9.04982 20.5997C8.59427 21.0552 7.85569 21.0552 7.40015 20.5997C6.94461 20.1442 6.94461 19.4056 7.40015 18.95L12.3503 13.9999L7.40015 9.0497C6.94461 8.59415 6.94461 7.85557 7.40015 7.40003C7.85569 6.94449 8.59427 6.94449 9.04982 7.40003L14 12.3502Z",
                fill: "white"
              })
            ]),
            _createElementVNode("defs", null, [
              _createElementVNode("clipPath", { id: "clip0_24929_239821" }, [
                _createElementVNode("rect", {
                  width: "28",
                  height: "28",
                  fill: "white"
                })
              ])
            ])
          ], -1)
        ]))]),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "continueInApp_illustrationGradient" }, null, -1))
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('postFirstDayModal.continueTitle')), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('postFirstDayModal.continueDesc')), 1)
      ]),
      _createElementVNode("ul", _hoisted_6, [
        _createElementVNode("li", _hoisted_7, [
          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "continueInApp_benefitIcon" }, [
            _createElementVNode("svg", {
              width: "22",
              height: "22",
              viewBox: "0 0 22 22",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                d: "M8.98394 19.9997C8.10769 19.7964 7.26601 19.4615 6.48652 19.0061M13.012 1.99969C15.0142 2.46529 16.8017 3.60926 18.0821 5.24429C19.3624 6.87931 20.0596 8.90852 20.0596 10.9997C20.0596 13.0908 19.3624 15.1201 18.0821 16.7551C16.8017 18.3901 15.0142 19.5341 13.012 19.9997M3.52486 16.2221C2.97612 15.4091 2.55895 14.5117 2.28924 13.5642M2.05964 9.46157C2.22076 8.48744 2.53092 7.56457 2.96596 6.71861L3.13615 6.40586M5.86921 3.39014C6.81199 2.73068 7.86883 2.25889 8.98394 1.99969",
                stroke: "var(--ac-color-blue)",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }),
              _createElementVNode("path", {
                d: "M8.05964 10.9997L10.0596 12.9997L14.0596 8.99969",
                stroke: "var(--ac-color-blue)",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              })
            ])
          ], -1)),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('postFirstDayModal.benefitProgress')), 1)
        ]),
        _createElementVNode("li", _hoisted_9, [
          _cache[8] || (_cache[8] = _createElementVNode("span", { class: "continueInApp_benefitIcon" }, [
            _createElementVNode("svg", {
              width: "22",
              height: "22",
              viewBox: "0 0 22 22",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                d: "M3.66667 15.5833V17.4167C3.66667 17.9029 3.85982 18.3692 4.20364 18.713C4.54745 19.0568 5.01377 19.25 5.5 19.25H16.5C16.9862 19.25 17.4525 19.0568 17.7964 18.713C18.1402 18.3692 18.3333 17.9029 18.3333 17.4167V15.5833M15.5833 10.0833L11 14.6667L6.41667 10.0833M11 14.6667V3.66667",
                stroke: "var(--ac-color-blue)",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              })
            ])
          ], -1)),
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('postFirstDayModal.benefitOffline')), 1)
        ]),
        _createElementVNode("li", _hoisted_11, [
          _cache[9] || (_cache[9] = _createElementVNode("span", { class: "continueInApp_benefitIcon" }, [
            _createElementVNode("svg", {
              width: "22",
              height: "22",
              viewBox: "0 0 16 22",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                d: "M11.39 0.75H4.11C2.25432 0.75 0.75 2.20205 0.75 3.99324V17.5068C0.75 19.2979 2.25432 20.75 4.11 20.75H11.39C13.2457 20.75 14.75 19.2979 14.75 17.5068V3.99324C14.75 2.20205 13.2457 0.75 11.39 0.75Z",
                stroke: "var(--ac-color-blue)",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }),
              _createElementVNode("path", {
                d: "M6.75 17.75H8.75",
                stroke: "var(--ac-color-blue)",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              })
            ])
          ], -1)),
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('postFirstDayModal.benefitHandy')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_unref(MqResponsive), { target: "mobile-tablet" }, {
          default: _withCtx(() => [
            _createVNode(AcButton, {
              block: "",
              "data-test": "continue-cta",
              onClick: onCta
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('postFirstDayModal.continueCta')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(AcButton, {
          class: "continueInApp_action -text",
          block: "",
          variant: "text",
          "data-test": "continue-stay",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (onClose('secondary_button')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('postFirstDayModal.stayInBrowser')), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})